module.exports = __webpack_public_path__ + "img/ticket-now.955bafe4.svg";